import React from 'react';
import PropertyShow from '../off_market_properties/property_show';

type Props = {
  inRethink: boolean;
  insightsPropertyId: string;
}

export default function Overview({
  insightsPropertyId,
  inRethink,
}: Props) {
  return (
    <PropertyShow
      fromConsole={true}
      fullscreen={false}
      hasProfile={true}
      inRethink={inRethink}
      insightsPropertyId={insightsPropertyId}
    />
  );
}
